export const brandedTokens = {
    brand: {
        primary: { main: '#5DB4E4', dark: '#4F5FAC', light: '#C8C8DD' },
        secondary: { main: '#E65274', dark: '#845BA4', light: '#929DB3' },
        text: { primary: '#373D3F', secondary: '#845BA4' },
        background: { default: '#FEFEFE', paper: '#FFFFFF' },
        action: { hover: '#E7E9EE', selected: '#dcdfe5' },
    },

    typography: { fontFamily: 'inherit' },
    zIndex: { appBar: 1200, drawer: 999 },

    variables: {
        primary: '#DCECF7',
        secondary: '#8793AB',
        success: '#28a745',
        info: '#DCECF7',
        warning: '#FFC107',
        error: '#F38B8F',
        light: '#F2F9FA',
        dark: '#343A40',

        white: '#FFFFFF',
        black87: 'rgba(0, 0, 0, 0.87)',

        gray: {
            100: '#f8f9fa',
            200: '#e9ecef',
            300: '#dee2e6',
            500: '#6c757d',
            600: '#6c757d',
            700: '#495057',
            800: '#343a40',
        },

        secondaryScale: {
            90: '#929DB3',
            80: '#9FA8BB',
            70: '#AAB3C4',
            60: '#B7BECC',
            50: '#C3C9D5',
            40: '#CFD4DD',
            30: '#DBDEE6',
            20: '#E7E9EE',
            10: '#F3F4F7',
        },
    },
} as const;

export type BrandedTokens = typeof brandedTokens;
